export class GMonInput {
  public topologyId: string;
  public ogmEnabled: boolean;
  public startDate: string;
  public endDate: string;
  public voltageQuantilesEnabled: boolean;
}
